import {Component, OnInit, Inject, ElementRef} from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
} from "@angular/forms";
import {
  CommonService,
  AlertService,
  AdminService,
  LeadService,
} from "../../_services/";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {emailListCreateContact} from "../../_helper/global";
// Algolia
import algoliasearch from "algoliasearch";
import {catchError, switchMap} from "rxjs/operators";
import {Router} from "@angular/router";

import {AngularFireFunctions} from "@angular/fire/functions";

// const client = algoliasearch(environment.algolia.appId, environment.algolia.adminAPIKey);
// const index = client.initIndex('contacts');
import {Subscription} from "rxjs";

@Component({
  selector: "app-add-lead-dialog",
  templateUrl: "./add-lead-dialog.component.html",
  styleUrls: ["./add-lead-dialog.component.scss"],
  host: {
    "(document:click)": "onClick($event)",
  },
  providers: [AngularFireFunctions],
})
export class AddLeadDialogComponent implements OnInit {
  addLeadForm: FormGroup;
  submitted = false;
  showJobFunction: Boolean = false;
  errMsg: String = "";
  locations: any;
  showrooms: any;
  designerList: any = [];
  contactSourceList: any = [];
  // associalteList:any=[];
  contactTypeList: any = [];
  contactType: String = "";
  jobFunctionList: any = [];
  workWithList: any[] = [];
  showTypeField: Boolean = true;
  showProjectAddress = false;
  appointmentTypeList: any[];
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  private subscription5: Subscription;
  constructor(
    public dialogRef: MatDialogRef<AddLeadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService,
    private _lead: LeadService,
    private _toastr: ToastrService,
    private _eref: ElementRef,
    private _router: Router,
    private fns: AngularFireFunctions
  ) {}

  ngOnInit() {
    this.jobFunctionList = this.data.jobFunctionList;
    this.workWithList = [
      {id: 54, name: "Architect", selected: false},
      {id: 55, name: "Interior Designer", selected: false},
      {id: 56, name: "General Contractor", selected: false},
    ];
    if (this.data && this.data.modalType == "add_lead") {
      this.contactType = "lead"; // id for leads
      this.showTypeField = false;
    }
    this.addLeadForm = this.fb.group({
      contact_type_id: [this.contactType == "" ? "" : "lead", []],
      job_functions: this.buildJobFunctions(),
      first_name: [null, []],
      last_name: [null, []],
      designer: [null, []],
      mobile_phone: [
        null,
        [Validators.minLength(10), Validators.maxLength(20)],
      ],
      email: [null, []],
      company: [null, []],
      address: [null, []],
      notes: [null, []],
      showroom: ["", []],
      contact_source_id: ["", []],
      owner_contact_id: ["", []],
      spoke_with_user_id: ["", []],
      working_with_id: this.buildWorkWithId(),
      category_id: ["", []],
      category_other: ["", []],
      home_address: ["", []],
      project_address: ["", []],
      project_budget: ["", []],
      project_appliances: ["", []],
      project_style_finishes: ["", []],
      calendar_event_type_id: ["", []],
      calendar_event_date_time: ["", []],
      purpose_of_visit: ["", []],
      source_description: ["", []],
      notes2: ["", []],
    });

    this.getShowroomList();
    this.getcontactSourceList();
    // this.getContactTypeList();
    this.fetchAppointmentType();
    if (emailListCreateContact.includes(localStorage.getItem("rs-email"))) {
      this.getDesignerList("all");
    } else {
      this.getDesignerList(localStorage.getItem("uid"));
    }
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes("location-area"))
      // or some similar check
      this.locations = [];
  }

  hideAddLeadDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.addLeadForm.controls;
  }

  getSuggestions(event) {
    // this._admin.getSuggestions(event.target.value).pipe(
    //   catchError((err: any)=>{

    //   }),
    //   switchMap((res:any)=>{
    //   this.locations = res["data"].map(item=>item.description);
    //   return res;
    // })).subscribe()
    this.subscription5 = this._admin
      .getSuggestions(event.target.value)
      .subscribe((res) => {
        this.locations = res["data"].map((item) => item.description);
      });
  }

  setLocation(locationName) {
    this.subscription5.unsubscribe();
    this.addLeadForm.patchValue({address: locationName});
    this.locations = [];
  }

  removeLocation() {
    // this.locations =[];
  }

  showHideFields(event) {
    this.showJobFunction = false;
    if (event.target.value === "staff") {
      // check if it is staff old ->  4wUNbQeEp9n4UsgwsMdG
      this.showJobFunction = true;
    }
  }

  changeType(event) {
    this.contactType = event.target.value;
  }

  // code for creating dynamic checkbox
  get job_functions() {
    return this.addLeadForm.get("job_functions") as FormArray;
  }
  // code for creating dynamic checkbox for signin form
  get working_with_id() {
    return this.addLeadForm.get("working_with_id") as FormArray;
  }

  buildJobFunctions() {
    if (this.jobFunctionList && this.jobFunctionList.length > 0) {
      const arr = this.jobFunctionList.map((item) => {
        return this.fb.control(item.selected);
      });
      return this.fb.array(arr);
    }
  }
  buildWorkWithId() {
    if (this.workWithList && this.workWithList.length > 0) {
      const arr = this.workWithList.map((item) => {
        return this.fb.control(item.selected);
      });
      return this.fb.array(arr);
    }
  }

  showHideProjectAddress(event) {
    if (event.target.value == "Yes") {
      this.showProjectAddress = false;
    } else {
      this.showProjectAddress = true;
    }
  }

  n(num) {
    return num > 9 ? num : "0" + num;
  }

  onFormSubmit(value): void {
    this.errMsg = "";
    this.submitted = true;
    if (value.mobile_phone && isNaN(parseFloat(value.mobile_phone))) {
      alert("Invalid phone number entered");
      return;
    }

    if (this.addLeadForm.invalid) {
      return;
    }
    let form = this.addLeadForm.value;
    form.uid = localStorage.getItem("uid");

    if (value.contact_type_id == "rs_2_import") {
      this._common.showLoader(true);
      this._lead
        .createContactRS2Import({uid: localStorage.getItem("uid")})
        .subscribe(
          (res: any) => {
            this._common.showLoader(false);
          },
          (error) => {
            console.error(error, "error occured while making http request!!");
          }
        );
    } else {
      if (value.contact_type_id == "staff") {
        const f = Object.assign({}, value, {
          job_functions: value.job_functions.map((s, i) => {
            return {
              name: this.jobFunctionList[i].name,
              id: this.jobFunctionList[i].id,
              selected: s,
            };
          }),
        });
        let oldJobFunctions = f.job_functions.filter((doc) => {
          if (doc.selected == true) {
            return doc;
          }
        });

        form.job_functions = [];
        for (let i = 0; i < oldJobFunctions.length; i++) {
          form.job_functions.push(oldJobFunctions[i].id);
        }
      }
      if (value.contact_type_id == "signin") {
        // Receive checkbox value
        const f2 = Object.assign({}, value, {
          working_with_id: value.working_with_id.map((s, i) => {
            return {
              name: this.workWithList[i].name,
              id: this.workWithList[i].id,
              selected: s,
            };
          }),
        });
        // const date = this.n(new Date(form.calendar_event_date_time).getMonth()+1)+"/"+this.n(new Date(form.calendar_event_date_time).getDate())+"/"+new Date(form.calendar_event_date_time).getFullYear();
        if (form.calendar_event_date_time) {
          const date = new Date(form.calendar_event_date_time).getTime();
          form.calendar_event_date_time = date;
        }
        let oldWorkWithId = f2.working_with_id.filter((doc) => {
          if (doc.selected == true) {
            return doc;
          }
        });

        form.working_with_id = [];
        for (let i = 0; i < oldWorkWithId.length; i++) {
          form.working_with_id.push(oldWorkWithId[i].id);
        }
        delete form.address;
        delete form.notes;
        delete form.job_functions;
        delete form.designer;
        form.date_created = new Date().getTime();
        form.date_updated = "";
        form.date_claimed = "";
        form.notes = form.notes2;
        form.phone_mobile = form.mobile_phone;
        delete form.mobile_phone;
        form.showroom_id = form.showroom;
        form.source_id = form.contact_source_id;
        delete form.contact_source_id;
        delete form.showroom;
        if (form.project_address == "") {
          form.project_address = form.home_address;
        }
        delete form.notes2;
        form.author_user_id = localStorage.getItem("uid");

        this._lead
          .createSignin(form)
          .then((res) => {
            this.dialogRef.close();
            this._common.showLoader(false);
            this._toastr.success("Sign-In successfully created", "", {
              timeOut: 5000,
            });
          })
          .catch((err) => {
            this._common.showLoader(false);
            this.errMsg = err.details ? err.details : "Something went wrong!";
          });
      } else {
        this._common.showLoader(true);
        if (window.location.host.includes("localhost")) {
          this.fns.functions.useFunctionsEmulator("http://localhost:5000");
        }
        const createContact = this.fns.httpsCallable("create_contact");
        createContact(form).subscribe(
          (res) => {
            this._common.showLoader(false);
            if (res.outcome === "success") {
              this.dialogRef.close();
              this._common.navigate("contact/" + res.contact_id);
            } else {
              this.submitted = false;
              this.errMsg = res.message;
              alert(this.errMsg);
            }
          },
          (err) => {
            this.submitted = false;
            this._common.showLoader(false);
            this.errMsg = err.details;
            alert(this.errMsg);
          }
        );
      }
    }
  }

  // get showroom list...
  getShowroomList() {
    this._common.showLoader(true);
    this.subscription = this._admin.geShowroomList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.showrooms = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get designer list...
  getDesignerList(listType) {
    this._common.showLoader(true);
    this.subscription2 = this._lead.getDesignerList(listType).subscribe(
      (result) => {
        this._common.showLoader(false);
        this.designerList = result.map((item) => item.payload.doc.data());
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get contact source list
  getcontactSourceList() {
    this._common.showLoader(true);
    this.subscription3 = this._admin.getContactSourceList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.contactSourceList = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get contact type list...
  /*  getContactTypeList(){
    this._common.showLoader(true);
    this.subscription4 = this._admin.getContactTypeList().subscribe(result=>{
      this._common.showLoader(false);
      this.contactTypeList = result;
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }*/

  // // Fetch appointment type...
  fetchAppointmentType() {
    this._admin.getCalendarEventTypeList().subscribe((res) => {
      this.appointmentTypeList = res.docs.map((item) => item.data());
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
    if (this.subscription5) this.subscription5.unsubscribe();
  }
}
